import { PipeTransform, Pipe } from '@angular/core';

@Pipe({ name: 'replace' })
export class ReplacePipe implements PipeTransform {
    transform(value: string, find: string, replace: string, flags?: string): string {
        let regexp = new RegExp(find, flags);
        return value.replace(regexp, replace);
    }
}
